/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.FameAdvantage {

    class ScheduleEditor {
        static $inject = [
            '$mdDialog'
        ];

        row: ITimeClockExportModel;

        constructor(protected $mdDialog: ng.material.IDialogService) {
        }

        cancel() {
            this.$mdDialog.cancel();
        }

        save() {
            this.$mdDialog.hide(this.row);
        }
    }

    angular.module('meevo.plugins.fameAdvantage')
        .controller('meevo.plugins.fameAdvantage.FameAdvantageScheduleEditor', ScheduleEditor);
}
